import React, { useState ,useEffect } from "react";
import { Handle, Position } from 'reactflow';
import useSyncNodeInternals from '../Components/useSyncNodeInternals';
import useAPI from "../../../../hooks/useAPI";

import { TiFlowMerge } from "react-icons/ti";
import { sendToast } from "../../../plugins/toastAll";
import NodeCardShell from '../Components/NodeCardShell';

const FLOWS_NODE_COLOR = '#B85C7C';

// Una sola petición compartida por todos los nodos de flujo: antes cada nodo
// pedía la lista al montarse, y el canvas los vuelve a montar al desplazarse.
const FLOWS_CACHE_MS = 60 * 1000;
let flowsRequest = null;
let flowsRequestAt = 0;
const loadFlows = (url, fetchWithAuth) => {
    if (!flowsRequest || Date.now() - flowsRequestAt > FLOWS_CACHE_MS) {
        flowsRequestAt = Date.now();
        flowsRequest = fetchWithAuth(url, { method: "GET", mode: "cors" })
            .then((response) => response.json())
            .catch((error) => {
                flowsRequest = null;
                throw error;
            });
    }
    return flowsRequest;
};

const FlowsWhatsApp = ({ data, isConnectable, id, selected }) => {
    const { urlAPI_2, fetchWithAuth } = useAPI();
    const [flows, setFlows] = useState([]);

    const getFlows = async () => {
        try {
            const result = await loadFlows(urlAPI_2 + "flows", fetchWithAuth);
            if (result.type === "error") {
                sendToast(result)
            }else if (result.message === 'Tu petición no tiene cabecera de autorización') {
                sendToast({type: "info", message: "Tu sesion ha caducado, verifica si alguien mas se ha conectado con tus credenciales"})
                navigate('/');
            }  else if (!result.data) {
                setFlows([]);
            } else {
                setFlows(result.data);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
            await Promise.all([
                getFlows(),
            ]);
            } catch (error) {
            console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, []);

    useSyncNodeInternals(id, `${data.saved}~${data.first}`);

    let flow = ""
    if(flows.length) {
        const find = flows.find(v => v._id == data.flow)
        if(find) {
            flow = find.name
        }
    }

    return (
        <NodeCardShell
          icon={TiFlowMerge}
          color={FLOWS_NODE_COLOR}
          typeName="Flujo WhatsApp"
          title={data.title ?? "Flujo de WhatsApp"}
          summary={flow}
          trigger={data.user_response}
          error={data?.error}
          selected={selected}
          handles={
            <>
              {data.saved && (
                <Handle
                  type="target"
                  position={Position.Top}
                  isConnectable={isConnectable}
                  id={`target-${id}`}
                  style={{backgroundColor: FLOWS_NODE_COLOR}}
                />
              )}
              {data.saved && (
                <Handle
                  type="source"
                  position={Position.Bottom}
                  id={`source-${id}`}
                  isConnectable={isConnectable}
                  style={{backgroundColor: FLOWS_NODE_COLOR}}
                />
              )}
            </>
          }
        />
    )
}

export default React.memo(FlowsWhatsApp);